export function opSlotCompact(){

}